import { render, staticRenderFns } from "./BoostLayout.vue?vue&type=template&id=e609873c&scoped=true"
import script from "./BoostLayout.vue?vue&type=script&lang=js"
export * from "./BoostLayout.vue?vue&type=script&lang=js"
import style0 from "./BoostLayout.vue?vue&type=style&index=0&id=e609873c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e609873c",
  null
  
)

export default component.exports